import { render, staticRenderFns } from "./ChurnForm.vue?vue&type=template&id=487c6fe2&scoped=true&"
import script from "./ChurnForm.vue?vue&type=script&lang=js&"
export * from "./ChurnForm.vue?vue&type=script&lang=js&"
import style0 from "./ChurnForm.vue?vue&type=style&index=0&id=487c6fe2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c6fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487c6fe2')) {
      api.createRecord('487c6fe2', component.options)
    } else {
      api.reload('487c6fe2', component.options)
    }
    module.hot.accept("./ChurnForm.vue?vue&type=template&id=487c6fe2&scoped=true&", function () {
      api.rerender('487c6fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pricing/UpgradeStepper/ChurnForm.vue"
export default component.exports